(function () {
  'use strict';

  if (window.__babyOnVisualReviewsRuntimeLoaded) return;
  window.__babyOnVisualReviewsRuntimeLoaded = true;

  var instances = new WeakMap();
  var pageLockCount = 0;
  var savedScrollY = 0;
  var savedBodyStyles = null;

  function toBoolean(value) {
    return value === true || value === 'true';
  }

  function number(value, fallback) {
    var parsed = parseFloat(value);
    return isNaN(parsed) ? fallback : parsed;
  }

  function ratingBucket(value) {
    return Math.max(1, Math.min(5, Math.round(number(value, 5))));
  }

  function lockPage() {
    pageLockCount += 1;
    if (pageLockCount > 1) return;

    savedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    savedBodyStyles = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width,
      overflow: document.body.style.overflow
    };

    document.documentElement.classList.add('bo-review-modal-open');
    document.body.classList.add('bo-review-modal-open');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }

  function unlockPage() {
    if (pageLockCount === 0) return;
    pageLockCount -= 1;
    if (pageLockCount > 0) return;

    document.documentElement.classList.remove('bo-review-modal-open');
    document.body.classList.remove('bo-review-modal-open');

    if (savedBodyStyles) {
      document.body.style.position = savedBodyStyles.position;
      document.body.style.top = savedBodyStyles.top;
      document.body.style.left = savedBodyStyles.left;
      document.body.style.right = savedBodyStyles.right;
      document.body.style.width = savedBodyStyles.width;
      document.body.style.overflow = savedBodyStyles.overflow;
    }

    window.scrollTo(0, savedScrollY);
    savedBodyStyles = null;
  }

  function initSection(section) {
    if (!section || instances.has(section)) return;

    var grid = section.querySelector('[data-bo-review-grid]');
    var modal = section.querySelector('[data-bo-review-modal]');
    var modalContent = section.querySelector('[data-bo-review-content]');
    var empty = section.querySelector('[data-bo-review-empty]');
    var actions = section.querySelector('[data-bo-review-actions]');
    var moreButton = section.querySelector('[data-bo-review-more]');
    var prevButton = section.querySelector('[data-bo-review-prev]');
    var nextButton = section.querySelector('[data-bo-review-next]');
    var summary = section.querySelector('[data-bo-review-summary]');
    var averageNode = section.querySelector('[data-bo-review-average]');
    var summaryStars = section.querySelector('[data-bo-review-summary-stars]');
    var summaryCount = section.querySelector('[data-bo-review-summary-count]');
    var filterButtons = Array.prototype.slice.call(section.querySelectorAll('[data-bo-review-filter]'));
    var productReviewLink = document.querySelector('[data-bo-product-review-link]');
    var productReviewStars = productReviewLink ? productReviewLink.querySelector('[data-bo-product-review-stars]') : null;
    var productReviewLabel = productReviewLink ? productReviewLink.querySelector('[data-bo-product-review-label]') : null;

    if (!grid || !modal || !modalContent) return;

    var currentProduct = section.getAttribute('data-current-product') || '';
    var showFallback = toBoolean(section.getAttribute('data-show-fallback'));
    var showOthers = toBoolean(section.getAttribute('data-show-others'));
    var mobileLimit = Math.min(parseInt(section.getAttribute('data-mobile-limit'), 10) || 5, 5);
    var desktopLimit = parseInt(section.getAttribute('data-desktop-limit'), 10) || 8;
    var reviewPool = section.querySelector('[data-bo-review-pool]');
    var poolScope = reviewPool && reviewPool.content ? reviewPool.content : grid;

    /* Product templates are support nodes, not review cards. Move them out of the inert pool. */
    if (reviewPool && reviewPool.content) {
      Array.prototype.slice.call(reviewPool.content.querySelectorAll('[data-bo-dynamic-product-template]')).forEach(function (template) {
        section.appendChild(template);
      });
    }

    var cards = Array.prototype.slice.call(poolScope.querySelectorAll('[data-bo-review-card]'));
    var usedClientNumbers = {};

    function stableHash(value) {
      var hash = 2166136261;
      var input = String(value || '');
      for (var index = 0; index < input.length; index += 1) {
        hash ^= input.charCodeAt(index);
        hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
      }
      return hash >>> 0;
    }

    function applyDisplayIdentity(card) {
      if (!card || card.getAttribute('data-bo-identity-ready') === 'true') return;

      var originalNameNode = card.querySelector('.bo-review-card__name');
      var originalName = originalNameNode ? originalNameNode.textContent.trim() : '';
      var dateNode = card.querySelector('.bo-review-card__date');
      var textNode = card.querySelector('.bo-review-card__text');
      var mediaNode = card.querySelector('.bo-review-card__image');
      var hasMedia = Boolean(card.querySelector('.bo-review-card__media, .bo-review-card__image, video'));
      var group = card.closest ? card.closest('[data-bo-channel-group]') : null;
      var channel = card.getAttribute('data-bo-channel') || (group ? group.getAttribute('data-bo-channel-group') : '');

      /* Existing manual reviews are already marked verified in the theme; do not invent a channel beyond that. */
      if (!channel && toBoolean(card.getAttribute('data-verified'))) channel = 'Compra Baby On';

      var key = [
        card.getAttribute('data-product-handle') || '',
        card.getAttribute('data-rating') || '',
        dateNode ? dateNode.textContent.trim() : '',
        textNode ? textNode.textContent.trim() : '',
        mediaNode ? (mediaNode.getAttribute('src') || '') : '',
        originalName
      ].join('|');

      var candidate = 10000 + (stableHash('BABYON-CLIENT-V1|' + key) % 90000);
      while (usedClientNumbers[candidate] && usedClientNumbers[candidate] !== key) {
        candidate = 10000 + ((candidate - 10000 + 7919) % 90000);
      }
      usedClientNumbers[candidate] = key;

      var label = 'Cliente #' + candidate;
      var channelDisplay = channel;

      /* Only text-only reviews need label variation. Media reviews keep their existing label. */
      if (!hasMedia && channel === 'Compra online') {
        var onlineLabels = ['Compra online', 'Pedido online', 'Compra por internet', 'Opinión de compra'];
        channelDisplay = onlineLabels[stableHash('BABYON-CHANNEL-V2|' + key) % onlineLabels.length];
      } else if (!hasMedia && channel === 'Compra Baby On') {
        var babyOnLabels = ['Compra Baby On', 'Pedido Baby On', 'Opinión Baby On'];
        channelDisplay = babyOnLabels[stableHash('BABYON-CHANNEL-V2|' + key) % babyOnLabels.length];
      }

      card.setAttribute('data-bo-client-label', label);
      card.setAttribute('data-bo-client-number', String(candidate));
      if (channel) card.setAttribute('data-bo-channel', channel);
      if (channelDisplay) card.setAttribute('data-bo-channel-display', channelDisplay);
      card.setAttribute('data-bo-identity-ready', 'true');

      if (originalNameNode) originalNameNode.textContent = label;

      var trigger = card.querySelector('[data-bo-review-open]');
      if (trigger) trigger.setAttribute('aria-label', 'Abrir reseña de ' + label);

      Array.prototype.forEach.call(card.querySelectorAll('.bo-review-card__image'), function (image) {
        var alt = image.getAttribute('alt') || '';
        if (originalName && alt.indexOf(originalName) !== -1) {
          image.setAttribute('alt', alt.split(originalName).join(label));
        }
      });

      if (channelDisplay) {
        var nameRow = card.querySelector('.bo-review-card__name-row');
        if (nameRow && !card.querySelector('.bo-review-card__channel')) {
          var badge = document.createElement('span');
          badge.className = 'bo-review-card__channel';
          badge.textContent = channelDisplay;
          nameRow.insertAdjacentElement('afterend', badge);
        }
      }
    }

    function applyModalIdentity(card, root) {
      if (!card || !root) return;
      var label = card.getAttribute('data-bo-client-label') || 'Cliente Baby On';
      var channel = card.getAttribute('data-bo-channel-display') || card.getAttribute('data-bo-channel') || '';

      Array.prototype.forEach.call(root.querySelectorAll('.bo-review-modal__name'), function (node) {
        node.textContent = label;
      });

      if (channel) {
        var row = root.querySelector('.bo-review-modal__name-row');
        if (row && !root.querySelector('.bo-review-modal__channel')) {
          var badge = document.createElement('span');
          badge.className = 'bo-review-modal__channel';
          badge.textContent = channel;
          row.insertAdjacentElement('afterend', badge);
        }
      }
    }

    cards.forEach(applyDisplayIdentity);

    var exactCards = cards.filter(function (card) {
      return currentProduct && (card.getAttribute('data-product-handle') || '') === currentProduct;
    });
    var fallbackCards = cards.filter(function (card) {
      return toBoolean(card.getAttribute('data-fallback'));
    });
    var otherCards = cards.filter(function (card) {
      return (card.getAttribute('data-product-handle') || '') !== currentProduct;
    });
    var eligibleCards = exactCards.length
      ? exactCards
      : (showFallback && fallbackCards.length ? fallbackCards : (showOthers ? otherCards : []));

    /* Visual proof first; text-only opinions follow after all photo/video cards. */
    eligibleCards = eligibleCards.map(function (card, index) {
      return { card: card, index: index, hasMedia: !!card.querySelector('.bo-review-card__media') };
    }).sort(function (a, b) {
      if (a.hasMedia !== b.hasMedia) return a.hasMedia ? -1 : 1;
      return a.index - b.index;
    }).map(function (entry) { return entry.card; });

    var usingFallback = !exactCards.length && eligibleCards.length > 0;
    var visibleCount = 0;
    var activeFilter = 'all';
    var activeIndex = -1;
    var lastFocused = null;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartedOnMedia = false;
    var touchGallery = null;

    section.classList.toggle('bo-visual-reviews--fallback', usingFallback);

    function bindReliableImage(img) {
      if (!img || img.getAttribute('data-bo-image-bound') === 'true') return;

      img.setAttribute('data-bo-image-bound', 'true');
      var originalSrc = img.getAttribute('src') || '';
      var retried = false;

      function markLoaded() {
        img.classList.remove('is-retrying', 'is-load-failed');
        img.classList.add('is-loaded');
      }

      function retryOnce() {
        if (retried || !originalSrc) {
          img.classList.remove('is-retrying');
          img.classList.add('is-load-failed');
          return;
        }

        retried = true;
        img.classList.add('is-retrying');
        window.setTimeout(function () {
          var separator = originalSrc.indexOf('?') === -1 ? '?' : '&';
          img.removeAttribute('srcset');
          img.src = originalSrc + separator + 'bo_retry=1';
        }, 450);
      }

      img.addEventListener('load', markLoaded);
      img.addEventListener('error', retryOnce);

      if (img.complete) {
        if (img.naturalWidth > 0) markLoaded();
        else retryOnce();
      }
    }

    function primeCardImage(card) {
      if (!card) return;
      var img = card.querySelector('.bo-review-card__image');
      if (!img) return;
      bindReliableImage(img);
      if (img.loading === 'lazy') img.loading = 'eager';
    }

    function cardRating(card) {
      return number(card.getAttribute('data-rating'), 5);
    }

    function getFilteredCards() {
      if (activeFilter === 'all') return eligibleCards.slice();
      var filterRating = parseInt(activeFilter, 10);
      return eligibleCards.filter(function (card) {
        return ratingBucket(cardRating(card)) === filterRating;
      });
    }

    function getLimit() {
      return window.matchMedia('(max-width: 749px)').matches ? mobileLimit : desktopLimit;
    }

    function setFilterState(value) {
      activeFilter = String(value || 'all');
      visibleCount = getLimit();

      filterButtons.forEach(function (button) {
        var active = button.getAttribute('data-bo-review-filter') === activeFilter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      refreshVisibility();
    }

    function refreshVisibility() {
      var filteredCards = getFilteredCards();
      var targetCount = Math.min(visibleCount || getLimit(), filteredCards.length);
      var fragment = document.createDocumentFragment();

      /* Keep only the visible batch in the live DOM. Remaining reviews stay detached/inert. */
      while (grid.firstChild) grid.removeChild(grid.firstChild);

      filteredCards.slice(0, targetCount).forEach(function (card) {
        card.hidden = false;
        card.classList.remove('is-hidden-by-filter', 'is-hidden-by-limit');
        primeCardImage(card);
        fragment.appendChild(card);
      });
      grid.appendChild(fragment);

      if (empty) {
        empty.textContent = eligibleCards.length
          ? 'No hay reseñas con esta calificación.'
          : 'Aún no hay reseñas para mostrar.';
        empty.hidden = filteredCards.length > 0;
      }

      if (actions) {
        actions.hidden = targetCount >= filteredCards.length;
      }

      if (moreButton && targetCount < filteredCards.length) {
        var remaining = filteredCards.length - targetCount;
        var nextBatch = Math.min(getLimit(), remaining);
        moreButton.textContent = 'Ver ' + nextBatch + ' reseñas más';
        moreButton.setAttribute('aria-label', 'Mostrar ' + nextBatch + ' reseñas más');
      }
    }

    function updateSummary() {
      if (!eligibleCards.length) {
        if (summary) summary.hidden = true;
        if (productReviewLink) productReviewLink.hidden = true;
        return;
      }

      var ratings = eligibleCards.map(cardRating);
      var average = ratings.reduce(function (sum, value) { return sum + value; }, 0) / ratings.length;
      var percent = Math.max(0, Math.min(100, (average / 5) * 100));
      var verifiedCount = eligibleCards.filter(function (card) {
        return toBoolean(card.getAttribute('data-verified'));
      }).length;

      if (averageNode) averageNode.textContent = average.toFixed(1);
      if (summaryStars) summaryStars.style.setProperty('--bo-rating-percent', percent.toFixed(2) + '%');
      if (summaryCount) {
        var noun = eligibleCards.length === 1 ? 'opinión' : 'opiniones';
        var verifiedCopy = verifiedCount === eligibleCards.length ? ' verificadas' : '';
        summaryCount.textContent = eligibleCards.length + ' ' + noun + verifiedCopy +
          (usingFallback ? ' de clientes Baby On' : ' de este producto');
      }
      if (summary) summary.hidden = false;

      [1, 2, 3, 4, 5].forEach(function (rating) {
        var count = ratings.filter(function (value) { return ratingBucket(value) === rating; }).length;
        var countNode = section.querySelector('[data-bo-review-rating-count="' + rating + '"]');
        var barNode = section.querySelector('[data-bo-review-rating-bar="' + rating + '"]');
        var filterButton = section.querySelector('[data-bo-review-filter="' + rating + '"]');
        var width = ratings.length ? (count / ratings.length) * 100 : 0;

        if (countNode) countNode.textContent = String(count);
        if (barNode) barNode.style.width = width.toFixed(2) + '%';
        if (filterButton) {
          filterButton.disabled = count === 0;
          filterButton.setAttribute('aria-label', rating + ' estrellas, ' + count + ' opiniones');
        }
      });

      if (productReviewLink && productReviewLabel && productReviewStars) {
        productReviewLink.hidden = false;
        productReviewStars.style.setProperty('--bo-rating-percent', percent.toFixed(2) + '%');
        var productNoun = eligibleCards.length === 1 ? 'opinión' : 'opiniones';
        productReviewLabel.textContent = usingFallback
          ? average.toFixed(1) + ' · ' + eligibleCards.length + ' ' + productNoun + ' de clientes'
          : average.toFixed(1) + ' · ' + eligibleCards.length + ' ' + productNoun;
        productReviewLink.setAttribute(
          'aria-label',
          'Ver ' + eligibleCards.length + ' ' + productNoun + (usingFallback ? ' de clientes Baby On' : ' de este producto')
        );

        if (!productReviewLink.getAttribute('data-bo-review-link-bound')) {
          productReviewLink.setAttribute('data-bo-review-link-bound', 'true');
          productReviewLink.addEventListener('click', function () {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        }
      }
    }

    function stopActiveVideo() {
      var videos = modalContent.querySelectorAll('video');
      Array.prototype.forEach.call(videos, function (video) {
        video.pause();
        try { video.currentTime = 0; } catch (error) { /* Safari can block reset before metadata. */ }
      });
    }

    /*
     * Videos dentro de <template> empiezan a cargar únicamente cuando se clona
     * la reseña dentro del modal. En algunos navegadores el primer play puede
     * avanzar el tiempo sin actualizar los fotogramas. Preparar un fotograma
     * mínimo antes de la reproducción inicializa el decodificador sin autoplay.
     */
    function prepareModalVideo(video) {
      if (!video) return;

      video.preload = 'auto';
      video.playsInline = true;

      if (video.getAttribute('data-bo-video-prepared') !== 'true') {
        video.setAttribute('data-bo-video-prepared', 'true');

        var warmFirstFrame = function () {
          if (!video.paused || video.ended || video.readyState < 2) return;
          if (video.currentTime > 0.005) return;

          var duration = Number(video.duration);
          var warmTime = 0.04;
          if (isFinite(duration) && duration > 0) {
            warmTime = Math.min(warmTime, Math.max(0.01, duration / 500));
          }

          try { video.currentTime = warmTime; } catch (error) { /* Some browsers block seeking until metadata is ready. */ }
        };

        video.addEventListener('loadeddata', warmFirstFrame);
        video.addEventListener('canplay', warmFirstFrame);

        video.addEventListener('play', function handleFirstPlay() {
          /* A tiny seek forces a fresh decoded frame if the poster layer stayed frozen. */
          if (video.currentTime <= 0.005 && video.readyState >= 2) {
            try { video.currentTime = 0.04; } catch (error) { /* noop */ }
          }
          video.removeEventListener('play', handleFirstPlay);
        });

        try { video.load(); } catch (error) { /* Native controls can still load the source normally. */ }
      }

      if (video.readyState >= 2) {
        window.requestAnimationFrame(function () {
          if (video.paused && video.currentTime <= 0.005) {
            try { video.currentTime = 0.04; } catch (error) { /* noop */ }
          }
        });
      }
    }

    function prepareModalVideos(root) {
      if (!root || !root.querySelectorAll) return;
      var videos = root.querySelectorAll('video');
      Array.prototype.forEach.call(videos, prepareModalVideo);
    }

    function initModalGallery(root) {
      if (!root || !root.querySelectorAll) return;
      var galleries = root.querySelectorAll('[data-bo-review-gallery]');
      Array.prototype.forEach.call(galleries, function (gallery) {
        if (gallery.__boGalleryReady) return;
        gallery.__boGalleryReady = true;

        var items = Array.prototype.slice.call(gallery.querySelectorAll('[data-bo-review-gallery-item]'));
        var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-bo-review-gallery-thumb]'));
        var prev = gallery.querySelector('[data-bo-review-gallery-prev]');
        var next = gallery.querySelector('[data-bo-review-gallery-next]');
        var active = 0;

        function updateThumbState(index) {
          thumbs.forEach(function (thumb, thumbIndex) {
            var isActive = thumbIndex === index;
            thumb.classList.toggle('is-active', isActive);
            thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            if (isActive && typeof thumb.scrollIntoView === 'function') {
              try { thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
              catch (error) { thumb.scrollIntoView(); }
            }
          });
        }

        function setActive(index) {
          if (!items.length) return;
          if (index < 0) index = items.length - 1;
          if (index >= items.length) index = 0;
          active = index;

          items.forEach(function (item, itemIndex) {
            var isActive = itemIndex === index;
            item.classList.toggle('is-active', isActive);
            item.hidden = !isActive;

            var video = item.querySelector('video');
            if (video) {
              if (isActive) {
                prepareModalVideo(video);
              } else {
                video.pause();
                try { video.currentTime = 0; } catch (error) { /* noop */ }
              }
            }
          });

          updateThumbState(index);
          if (prev) prev.disabled = items.length <= 1;
          if (next) next.disabled = items.length <= 1;
        }

        if (prev) prev.addEventListener('click', function (event) {
          event.stopPropagation();
          setActive(active - 1);
        });

        if (next) next.addEventListener('click', function (event) {
          event.stopPropagation();
          setActive(active + 1);
        });

        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function (event) {
            event.stopPropagation();
            var index = parseInt(thumb.getAttribute('data-index'), 10) || 0;
            setActive(index);
          });
        });

        gallery.__boGalleryCount = items.length;
        gallery.__boGalleryNext = function () { setActive(active + 1); };
        gallery.__boGalleryPrevious = function () { setActive(active - 1); };

        setActive(0);
      });
    }

    function getModalCards() {
      var filtered = getFilteredCards();
      return filtered.length ? filtered : eligibleCards;
    }

    function updateNavigation() {
      var hasMultiple = getModalCards().length > 1;
      if (prevButton) prevButton.disabled = !hasMultiple;
      if (nextButton) nextButton.disabled = !hasMultiple;
    }

    function renderDynamicTextReview(card) {
      modalContent.innerHTML = '';

      var layout = document.createElement('div');
      layout.className = 'bo-review-modal__layout bo-review-modal__layout--text-only';
      var details = document.createElement('div');
      details.className = 'bo-review-modal__details';
      var review = document.createElement('div');
      review.className = 'bo-review-modal__review';

      var name = card.querySelector('.bo-review-card__name');
      var nameRow = document.createElement('div');
      nameRow.className = 'bo-review-modal__name-row';
      var heading = document.createElement('h3');
      heading.className = 'bo-review-modal__name';
      heading.textContent = name ? name.textContent : 'Cliente Baby On';
      nameRow.appendChild(heading);
      review.appendChild(nameRow);

      var channel = card.getAttribute('data-bo-channel-display') || card.getAttribute('data-bo-channel') || '';
      if (channel) {
        var channelNode = document.createElement('span');
        channelNode.className = 'bo-review-modal__channel';
        channelNode.textContent = channel;
        review.appendChild(channelNode);
      }

      var date = card.querySelector('.bo-review-card__date');
      if (date) {
        var dateNode = document.createElement('p');
        dateNode.className = 'bo-review-modal__date';
        dateNode.textContent = date.textContent;
        review.appendChild(dateNode);
      }

      var cardRatingValue = cardRating(card);
      var cardRatingRow = card.querySelector('.bo-review-card__rating-row');
      if (cardRatingRow) {
        var ratingRow = document.createElement('div');
        ratingRow.className = 'bo-review-modal__rating-row';
        var starsNode = document.createElement('div');
        starsNode.className = 'bo-review-modal__stars';
        starsNode.setAttribute('aria-label', cardRatingValue + ' de 5 estrellas');
        for (var starIndex = 1; starIndex <= 5; starIndex += 1) {
          var star = document.createElement('span');
          star.className = 'bo-review-modal__star' + (starIndex > cardRatingValue ? ' is-empty' : '');
          star.setAttribute('aria-hidden', 'true');
          star.textContent = '★';
          starsNode.appendChild(star);
        }
        var numberNode = document.createElement('strong');
        numberNode.className = 'bo-review-modal__rating-number';
        numberNode.textContent = cardRatingValue + '/5';
        ratingRow.appendChild(starsNode);
        ratingRow.appendChild(numberNode);
        review.appendChild(ratingRow);
      }

      var textNode = card.querySelector('.bo-review-card__text');
      if (textNode && textNode.textContent.trim()) {
        var modalText = document.createElement('div');
        modalText.className = 'bo-review-modal__text';
        modalText.textContent = textNode.textContent;
        review.appendChild(modalText);
      }

      details.appendChild(review);

      var productHandle = card.getAttribute('data-product-handle') || '';
      var productTemplate = section.querySelector('[data-bo-dynamic-product-template="' + productHandle + '"]');
      if (productTemplate && productTemplate.content) {
        details.appendChild(productTemplate.content.cloneNode(true));
      }

      layout.appendChild(details);
      modalContent.appendChild(layout);
      modalContent.scrollTop = 0;
    }

    function renderModal(index) {
      var modalCards = getModalCards();
      if (!modalCards.length) return;

      if (index < 0) index = modalCards.length - 1;
      if (index >= modalCards.length) index = 0;

      activeIndex = index;
      stopActiveVideo();

      var activeCard = modalCards[index];
      var template = activeCard.querySelector('[data-bo-review-template]');
      var isDynamicTextReview = activeCard.getAttribute('data-bo-dynamic-text-review') === 'true';

      if (!template && isDynamicTextReview) {
        renderDynamicTextReview(activeCard);
      } else {
        if (!template) return;
        modalContent.innerHTML = '';
        modalContent.appendChild(template.content.cloneNode(true));
        applyModalIdentity(activeCard, modalContent);
        modalContent.scrollTop = 0;
        prepareModalVideos(modalContent);
        initModalGallery(modalContent);
      }

      var reviewScroller = modalContent.querySelector('.bo-review-modal__review');
      if (reviewScroller) reviewScroller.scrollTop = 0;

      updateNavigation();
    }

    function openModal(card, trigger) {
      var modalCards = getModalCards();
      var index = modalCards.indexOf(card);
      if (index < 0) index = eligibleCards.indexOf(card);
      if (index < 0) return;

      lastFocused = trigger || document.activeElement;
      renderModal(index);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      lockPage();

      /* Reconfirm video readiness after the modal is visible/composited. */
      window.requestAnimationFrame(function () {
        prepareModalVideos(modalContent);
      });

      var close = modal.querySelector('[data-bo-review-close].bo-review-modal__close');
      window.setTimeout(function () {
        if (close) close.focus({ preventScroll: true });
      }, 40);
    }

    function closeModal() {
      if (!modal.classList.contains('is-open')) return;

      stopActiveVideo();
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      modalContent.innerHTML = '';
      unlockPage();

      if (lastFocused && typeof lastFocused.focus === 'function') {
        window.setTimeout(function () {
          try { lastFocused.focus({ preventScroll: true }); }
          catch (error) { lastFocused.focus(); }
        }, 20);
      }
    }

    function nextReview() {
      renderModal(activeIndex + 1);
    }

    function previousReview() {
      renderModal(activeIndex - 1);
    }

    grid.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-bo-review-open]');
      if (!trigger) return;

      var card = trigger.closest('[data-bo-review-card]');
      if (!card) return;

      openModal(card, trigger);
    });

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-bo-review-close]')) {
        closeModal();
        return;
      }

      if (event.target.closest('[data-bo-review-prev]')) {
        previousReview();
        return;
      }

      if (event.target.closest('[data-bo-review-next]')) {
        nextReview();
      }
    });

    modal.addEventListener('touchstart', function (event) {
      touchStartedOnMedia = !!event.target.closest('.bo-review-modal__media-wrap');
      touchGallery = event.target.closest('[data-bo-review-gallery]');
      if (!touchStartedOnMedia || !event.touches || event.touches.length !== 1) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });

    modal.addEventListener('touchend', function (event) {
      if (!touchStartedOnMedia || !event.changedTouches || event.changedTouches.length !== 1) return;
      touchStartedOnMedia = false;

      var deltaX = event.changedTouches[0].clientX - touchStartX;
      var deltaY = event.changedTouches[0].clientY - touchStartY;
      var activeTouchGallery = touchGallery;
      touchGallery = null;

      if (Math.abs(deltaX) < 55 || Math.abs(deltaX) < Math.abs(deltaY) * 1.25) return;

      if (activeTouchGallery && activeTouchGallery.__boGalleryCount > 1) {
        if (deltaX < 0 && activeTouchGallery.__boGalleryNext) activeTouchGallery.__boGalleryNext();
        if (deltaX > 0 && activeTouchGallery.__boGalleryPrevious) activeTouchGallery.__boGalleryPrevious();
        return;
      }

      if (deltaX < 0) nextReview();
      else previousReview();
    }, { passive: true });

    document.addEventListener('keydown', function (event) {
      if (!modal.classList.contains('is-open')) return;

      if (event.key === 'Escape') closeModal();
      if (event.key === 'ArrowRight') nextReview();
      if (event.key === 'ArrowLeft') previousReview();
    });

    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        setFilterState(button.getAttribute('data-bo-review-filter') || 'all');
      });
    });

    if (moreButton) {
      moreButton.addEventListener('click', function () {
        visibleCount += getLimit();
        refreshVisibility();
      });
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        if (visibleCount < getLimit()) visibleCount = getLimit();
        refreshVisibility();
      }, 120);
    });

    updateSummary();
    setFilterState('all');
    instances.set(section, { refresh: refreshVisibility, close: closeModal });
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll ? scope.querySelectorAll('[data-bo-visual-reviews]') : [];
    Array.prototype.forEach.call(sections, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
